// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sx-editor-table {\n  position: relative;\n}\n.sx-editor-table h4 {\n  height: 25px;\n  margin-bottom: 14px;\n  margin-top: 10px;\n}\n.ag-table {\n  height: 32.5rem !important;\n  min-height: 25.5rem !important;\n}\n.sx-editor-actions {\n  position: absolute;\n  z-index: 10;\n  top: -8px;\n  right: 0px;\n  display: flex;\n}\n.sx-editor-actions > * {\n  margin-left: 5px;\n}\n.sx-editor-actions .v-input {\n  margin-top: -0.1rem;\n}\ntbody td {\n  font-size: 0.8rem !important;\n}", ""]);
// Exports
module.exports = exports;
